import { Modal } from '../modal'

interface StartedReviewModalProps {
  isOpen: boolean
  setOpen: (value: boolean) => void
  submitButtonAction?: () => void
  backButtonAction?: () => void
  isPendingStartReview?: boolean
}

export const StartedReviewModal = ({
  isOpen,
  setOpen,
  submitButtonAction,
  backButtonAction,
  isPendingStartReview,
}: StartedReviewModalProps) => {
  return (
    <Modal
      backButtonLabel="Ir para esta Análise"
      submitButtonLabel="Voltar a fila geral"
      backButtonAction={backButtonAction}
      title="Iniciar Análise"
      submitAction={submitButtonAction}
      pendingSubmit={isPendingStartReview}
      isOpen={isOpen}
      setOpen={setOpen}
    >
      <div className="flex flex-col items-center justify-center gap-6 my-5">
        <p className="text-[var(--brand-green)] font-bold text-2xl">
          Análise Iniciada!
        </p>
        <p className="text-center">
          Deseja ir para a tela das suas análises ou voltar as solicitações não
          iniciadas
        </p>
      </div>
    </Modal>
  )
}
